import { RouteObject } from "react-router-dom";
import { PageLayoutDefaultMenuNavigationGroup } from "@sis/react-library";
import MiscellaneousServicesIcon from '@mui/icons-material/MiscellaneousServices';
import { OtherSamplesFeedbackPage } from "./otherSamplesPages/otherSamplesFeedbackPage/OtherSamplesFeedbackPage";
import { OtherSamplesAlertsPage } from "./otherSamplesPages/otherSamplesAlertsPage/OtherSamplesAlertsPage";
import { OtherSamplesPageLayoutPage } from "./otherSamplesPages/otherSamplesPageLayoutPage/OtherSamplesPageLayoutPage";
import { OtherSamplesThemePage } from "./otherSamplesPages/otherSamplesThemePage/OtherSamplesThemePage";
import { OtherSamplesVitePluginPage } from "./otherSamplesPages/otherSamplesVitePluginPage/OtherSamplesVitePluginPage";

const url = "otherSamples";

// Allow is same file
// eslint-disable-next-line
export const otherSamplesRoutes = {
    feedback: `/${url}/feedback`,
    alerts: `/${url}/alerts`,
    pageLayout: `/${url}/pageLayout`,
    theme: `/${url}/theme`,
    vitePlugin: `/${url}/vitePlugin`
}

export const OtherSamplesNavigation = (): RouteObject[] => {
    return [
        {
            path: otherSamplesRoutes.feedback,
            element: <OtherSamplesFeedbackPage />
        },
        {
            path: otherSamplesRoutes.alerts,
            element: <OtherSamplesAlertsPage />
        },
        {
            path: otherSamplesRoutes.pageLayout,
            element: <OtherSamplesPageLayoutPage />
        },
        {
            path: otherSamplesRoutes.theme,
            element: <OtherSamplesThemePage />
        },
        {
            path: otherSamplesRoutes.vitePlugin,
            element: <OtherSamplesVitePluginPage />
        }        
    ]
}

// Allow in same file
// eslint-disable-next-line
export const OtherSamplesMenuItem: PageLayoutDefaultMenuNavigationGroup = {
    icon: <MiscellaneousServicesIcon />, text: 'Other', items: [
        { text: 'Feedback', navigateTo: otherSamplesRoutes.feedback },
        { text: 'Alerts', navigateTo: otherSamplesRoutes.alerts },
        { text: 'Page Layout', navigateTo: otherSamplesRoutes.pageLayout },
        { text: 'Theme', navigateTo: otherSamplesRoutes.theme },
        { text: 'Vite Plugin', navigateTo: otherSamplesRoutes.vitePlugin }
    ]
}
